import { computed, type ComputedRef } from 'vue'
import { useRouter } from 'vue-router'
import type { MenuItemWithRelatedPaths } from '@cplug/frontend-core/composables'
import { BaseIconName } from '@cplug/design-system/components/props'
import {
  COMING_SOON_PRODUCT_PATHS,
  type ComingSoonProduct
} from '../models/ComingSoonProduct'
import { useComingSoonProductMenusTranslation } from './useComingSoonProductMenus.i18n'

export function useComingSoonProductMenus (product: ComingSoonProduct): {
  mainMenu: ComputedRef<MenuItemWithRelatedPaths[]>
} {
  const router = useRouter()
  const { t } = useComingSoonProductMenusTranslation()
  const path = COMING_SOON_PRODUCT_PATHS[product]
  const navigateTo = (): void => {
    router.push(path)
  }

  const mainMenu = computed<MenuItemWithRelatedPaths[]>(() => {
    if (product === 'loja') {
      return [
        { name: 'store-overview', label: t('StoreOverview'), icon: BaseIconName.Shop, command: navigateTo },
        { name: 'store-settings', label: t('StoreSettings'), icon: BaseIconName.Settings, command: navigateTo },
        { name: 'store-personalization', label: t('StorePersonalization'), icon: BaseIconName.Palette, command: navigateTo },
        { name: 'store-order-modes', label: t('StoreOrderModes'), icon: BaseIconName.Truck, command: navigateTo },
        { name: 'store-payments', label: t('StorePayments'), icon: BaseIconName.Wallet, command: navigateTo },
        { name: 'store-products', label: t('StoreProducts'), icon: BaseIconName.Tag, command: navigateTo }
      ]
    }

    return [
      { name: 'payments-account', label: t('PaymentsAccount'), icon: BaseIconName.User, command: navigateTo },
      { name: 'payments-statement', label: t('PaymentsStatement'), icon: BaseIconName.Receipt, command: navigateTo },
      { name: 'payments-receipts', label: t('PaymentsReceipts'), icon: BaseIconName.ArrowDownLeft, command: navigateTo },
      { name: 'payments-anticipation', label: t('PaymentsAnticipation'), icon: BaseIconName.TrendingUp, command: navigateTo },
      { name: 'payments-payment-link', label: t('PaymentsPaymentLink'), icon: BaseIconName.Link, command: navigateTo },
      { name: 'payments-simulator', label: t('PaymentsSimulator'), icon: BaseIconName.Calculator, command: navigateTo },
      { name: 'payments-devices', label: t('PaymentsDevices'), icon: BaseIconName.Desktop, command: navigateTo }
    ]
  })

  return { mainMenu }
}
